import { Outlet, useMatches } from 'react-router-dom';
import { AuthCard } from './AuthCard';
import icon from '@assets/dd-icon.png';

const AuthLayout = () => {
  const matches = useMatches();
  const current = matches[matches.length - 1] as { handle?: { title: string } };
  const title = current?.handle?.title || ' DrillDown Auth';
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="sm:mx-auto sm:w-full sm:max-w-md mb-10">
        <img alt="DrillDown" src={icon} className="mx-auto h-16 w-auto" />
        <h2 className="mt-6 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
          {title}
        </h2>
      </div>
      <AuthCard>
        <Outlet />
      </AuthCard>
    </div>
  );
};

export default AuthLayout;
